/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateMailTemplateResponseData,
  CreateMailTemplateResponseDataFromJSON,
  CreateMailTemplateResponseDataFromJSONTyped,
  CreateMailTemplateResponseDataToJSON
} from './CreateMailTemplateResponseData'

/**
 *
 * @export
 * @interface CopyMailTemplateResponse
 */
export interface CopyMailTemplateResponse {
  /**
   *
   * @type {number}
   * @memberof CopyMailTemplateResponse
   */
  status?: number
  /**
   *
   * @type {CreateMailTemplateResponseData}
   * @memberof CopyMailTemplateResponse
   */
  data?: CreateMailTemplateResponseData
}

export function CopyMailTemplateResponseFromJSON(json: any): CopyMailTemplateResponse {
  return CopyMailTemplateResponseFromJSONTyped(json, false)
}

export function CopyMailTemplateResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CopyMailTemplateResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateMailTemplateResponseDataFromJSON(json['data'])
  }
}

export function CopyMailTemplateResponseToJSON(value?: CopyMailTemplateResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateMailTemplateResponseDataToJSON(value.data)
  }
}
